import EmailIcon from "../icons/emailIcon";
import LocationIcon from "../icons/locationIcon";
import MobileNumberIcon from "../icons/MobileNumberIcon"
import PhoneNumberIcon from "../icons/phoneNumberIcon";

import { ContactInformationType } from "./types";

export const contactInfo: ContactInformationType[] = [
  {
    id: 0,
    title: "021-91072200",
    icon: PhoneNumberIcon,
    link: "tel:021-91072200",
  },
  {
    id: 1,
    title: ["0991-1801094", "0991-1801095"],
    icon: MobileNumberIcon,
    link: ["tel:0991-1801094", "tel:0991-1801095"],
  },
  {
    id: 2,
    title: "info@tabargh.com",
    icon: EmailIcon,
    link: "mailto:faranab@gmail.com",
  },
  {
    id: 3,
    title:
      "سعادت آباد، بلوار دریا، خیابان مطهری، کوچه عیسی پور، پلاک 15، واحد 5",
    icon: LocationIcon,
    link: "https://www.google.com/maps/dir/?api=1&destination=35.771585, 51.365994",
  },
];
